// https://www.figma.com/file/O0FWE4TJWmIGCksbLUEL0i0y/%E2%9D%96-Web-Component-Library?node-id=11%3A6096
export var radii = {
  corner: '0',
  small: '4px',
  medium: '8px',
  round: '50%'
};
//# sourceMappingURL=radii.js.map